import React, { useEffect, useState } from 'react';
import Select from 'react-select';

import { supabase } from '../../utils/supabase';

const customStyles = {
  container: (provided) => ({
    ...provided,
    flexGrow: 1,
  }),
  control: (provided) => ({
    ...provided,
    width: '100%',
  }),
};

function DesignerSelect({ onChange, value }) {
  const [designers, setDesigners] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchDesigners = async () => {
      try {
        const { data } = await supabase
          .from('golf_course_designers')
          .select('course_designer')
          .order('course_designer', { ascending: true })
          .range(0, 300);

        const formattedDesigners = data.map((designer) => ({
          label: designer.course_designer,
          value: designer.course_designer,
        }));

        setDesigners(formattedDesigners);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching designers:', error);
      }
    };
    fetchDesigners();
  }, []);

  return (
    <>
      <Select
        options={designers}
        isLoading={isLoading}
        value={designers.find((designer) => designer.value === value)}
        onChange={onChange}
        styles={customStyles}
        placeholder="Select a designer..."
      />
    </>
  );
}

export default DesignerSelect;
